import React, {Fragment} from 'react'
import InputField from 'admin/components/shared/InputField'
import {formatNumber} from 'admin/lib/format'

export default ({items, onChange, errors = [], disabled = false}) => {
  if (!items || !items.length) items = [{}]

  const handleItemChange = (index, changes) => {
    const updatedItems = [...items]

    updatedItems[index] = {
      ...updatedItems[index],
      ...changes
    }

    onChange(updatedItems)
  }

  const handleAddItem = e => {
    e.preventDefault()
    onChange([...items, {}])
  }

  const handleRemoveItem = (index, e) => {
    e.preventDefault()
    let lineItems = [...items]
    lineItems.splice(index, 1)
    onChange(lineItems)
  }

  return (
    <div className='line-items'>
      {items.map(({description, unitPrice, quantity}, i) => {
        const onItemChange = changes => handleItemChange(i, changes)
        const error = errors.find(err => err.index == i) || {}
        const onRemove = event => handleRemoveItem(i, event)

        return (
          <div className='field is-grouped' key={i}>
            <div className='control is-expanded'>
              <InputField
                showLabel={i === 0}
                type='text'
                id={`description_${i}`}
                name='description'
                value={description || ''}
                onChange={onItemChange}
                style={{flexGrow: 2}}
                errors={error.description}
              />
            </div>
            <div className='control'>
              <InputField
                showLabel={i === 0}
                type='number'
                id={`quantity_${i}`}
                name='quantity'
                min={0}
                value={quantity === 0 ? 0 : quantity || ''}
                onChange={onItemChange}
                errors={error.quantity}
                disabled={disabled}
              />
            </div>
            <div className='control'>
              <InputField
                showLabel={i === 0}
                type='number'
                id={`unitPrice_${i}`}
                name='unitPrice'
                label='Unit price'
                step={0.5}
                value={unitPrice === 0 ? 0 : unitPrice || ''}
                onChange={onItemChange}
                errors={error.unitPriceExclGst}
                disabled={disabled}
              />
            </div>

            <div className='control amount'>
              <div className='field'>
                {i === 0 && <label className='label is-small has-text-right'>Amount</label>}
                <div className='control px-0'>
                  <span className='value'>{formatNumber(unitPrice * quantity, {thousands: true})}</span>
                </div>
              </div>
            </div>
            {!disabled && (
              <div className='control remove'>
                <div className='field'>
                  {i === 0 ? (
                    <Fragment>
                      <div className='control'>
                        <div className='button is-text is-invisible'>
                          <span className='icon is-small'></span>
                        </div>
                      </div>
                    </Fragment>
                  ) : (
                    <div className='control'>
                      <a className='button is-text' onClick={onRemove}>
                        <span className='icon is-small'>
                          <i className='fa fa-times' aria-hidden='true'></i>
                        </span>
                      </a>
                    </div>
                  )}
                </div>
              </div>
            )}
          </div>
        )
      })}

      {!disabled && (
        <button href='' className='button is-outlined is-dark' onClick={handleAddItem}>
          Add a new line
        </button>
      )}
    </div>
  )
}
